import { ModuleWithProviders, NgModule } from '@angular/core';
import { AccountNavigationService } from './account-router/account-navigation.service';
import { AccountDisabledServiceToken, AuthenticationServiceToken } from './account-services';

@NgModule()
export class AccountServicesModule {
  constructor(accountNavigationService: AccountNavigationService) {
    accountNavigationService.init();
  }

  static withServices(authenticationService: any, accountDisabledService: any): ModuleWithProviders<AccountServicesModule> {
    return {
      ngModule: AccountServicesModule,
      providers: [
        { provide: AuthenticationServiceToken, useClass: authenticationService },
        { provide: AccountDisabledServiceToken, useClass: accountDisabledService }
      ]
    };
  }
}
